// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TerceraMainHeaderButton } from "./TerceraMainHeaderButton.js";
import { DataCache } from "../../Commons/DataCache.ts";

export let IdeasButton = TerceraMainHeaderButton.extend({});

IdeasButton.prototype.getType = function () { return 'IdeasButton' };

IdeasButton.prototype.oncomplete = function ()
{
    TerceraMainHeaderButton.prototype.oncomplete.apply(this);

    DataCache.OnTradingIdeaAdd.Subscribe(this.onIdeasNumberChanged, this)
    DataCache.OnTradingIdeaCancel.Subscribe(this.decrementCounter, this)
    DataCache.OnTradingSignalRequestSend.Subscribe(this.onIdeasNumberChanged, this)
    DataCache.OnTradingIdeaFirstOpen.Subscribe(this.decrementCounter, this)

    DataCache.OnTradingSystemUnsubscribe.Subscribe(this.onIdeasNumberChanged, this)
};

IdeasButton.prototype.dispose = function ()
{
    DataCache.OnTradingIdeaAdd.UnSubscribe(this.onIdeasNumberChanged, this)
    DataCache.OnTradingIdeaCancel.Subscribe(this.decrementCounter, this)
    DataCache.OnTradingSignalRequestSend.UnSubscribe(this.onIdeasNumberChanged, this)
    DataCache.OnTradingIdeaFirstOpen.UnSubscribe(this.decrementCounter, this)

    DataCache.OnTradingSystemUnsubscribe.UnSubscribe(this.onIdeasNumberChanged, this)

    TerceraMainHeaderButton.prototype.dispose.apply(this);
}

IdeasButton.prototype.onIdeasNumberChanged = function ()
{
    let oldValue = this.get('counter'),
        newValue = this.getNotSeenIdeasNumber()

    // if (newValue > 0)
    //     this.startCounterBlinking()      // comment out due to #112700

    this.set('counter', newValue)
}

IdeasButton.prototype.decrementCounter = function (idea)
{
    let oldValue = this.get('counter')

    if (!oldValue)
        return   // can't be less than zero

    if (idea && !idea.wasNotRead)
        return   // to need to decrement counter if idea has been read

    this.set('counter', oldValue - 1)
}

IdeasButton.prototype.getNotSeenIdeasNumber = function ()
{
    let ideas = DataCache.tradingIdeas,
        keys = Object.keys(ideas),
        result = 0

    for (let i = 0; i < keys.length; i++)
    {
        let idea = ideas[keys[i]]

        if (idea.wasNotRead)
            result++
    }

    return result
}